(function() {
    const blocAnnuaireMenuSticky = document.querySelector('.bloc_annuaire_menu_sticky');
    const mpCloseAnnuaire = blocAnnuaireMenuSticky.querySelector('.mp-close-annuaire');
    const searchInput = blocAnnuaireMenuSticky.querySelector('.search__input');
    const boutonServiceAnnuaire = document.querySelectorAll('.bouton_service_annuaire');

    let menuOpen = false;

    for (const bouton of boutonServiceAnnuaire) {
        bouton.addEventListener('click', () => {
            menuOpen = !menuOpen;
            updateUi();
        });
    }
    mpCloseAnnuaire.addEventListener('click', () => {
        menuOpen = false;
        updateUi();
    });

    function updateUi() {
        blocAnnuaireMenuSticky.classList.toggle('menu-annuaire--opened', menuOpen);
        for (const bouton of boutonServiceAnnuaire) {
            bouton.parentElement.classList.toggle('menu-sticky__item--actif', menuOpen);
        }
        if (menuOpen) {
            setTimeout(() => {
                searchInput.focus();
            }, 300)
        }
    }
})();